/** Function is remove whitespace from a pasted string */
export const parsePastedSignUpCode = (signUpCode: string) => (signUpCode || '').replace(/\s/g, '').split('');
